import axios from 'axios';
import { req } from './axiosFun';

//查询所有的一级类目
export const appone = (params) => { return req("get", "/zixun/appone") };
//图形验证码
export const create = (params) => { return req("get", "/code/create") };

//新增报道
export const veteranadd = (params) => { return req("post", "/veteran/add", params) };

//根据一级分类查询二级分类
export const apptwo = (params) => { return req("post", "/zixun/apptwo", params) };
//根据耳机分类查询内容
export const selectbytwo = (params) => { return req("post", "/lbinfo/selectbytwo", params) };



// WEBPACK FOOTER //
// ./src/api/category.js